import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from '../PageNotFound/pageNotFound.component';
import { DocumentacionComponent } from '../documentacion/documentacion.component';
import { PolizaComponent } from '../poliza/poliza.component';
import { ParametrizacionComponent } from '../parametrizacion/parametrizacion.component';
import { ParametrizacionEnlacesComponent } from '../parametrizacion-enlaces/parametrizacion-enlaces.component';
import { ReportesComponent } from '../reportes/reportes.component';
import { ImpresionComponent } from '../impresion/impresion.component';
import { EnlacePrincipalComponent } from '../enlace-principal/enlace-principal.component';
import { ConfiguracionesComponent } from '../configuraciones/configuraciones.component';

const routes: Routes = [
  { path: '', component: PolizaComponent, pathMatch: "full" },
  { path: 'documentacion', component: DocumentacionComponent, pathMatch: "full" },
  { path: 'parametrizacion', component: ParametrizacionComponent, pathMatch: "full" },
  {path: 'enlaceprincipal', component: EnlacePrincipalComponent, pathMatch:"full"},
  {path: 'configuraciones', component: ConfiguracionesComponent, pathMatch:"full"},
  { path: 'parametrizacionEnlaces', component: ParametrizacionEnlacesComponent, pathMatch: "full" },
  { path: 'reportes', component: ReportesComponent, pathMatch: "full" },
  { path: 'impresion', component: ImpresionComponent, pathMatch: "full" },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
      RouterModule.forRoot(routes)
  ],
  exports: [
      RouterModule
  ],
  declarations: []
})
export class AppRoutingModule { }
